export default __webpack_public_path__ + "static/media/closet5-before2-1440w.c5a4c884.webp";